var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71852 16.8637C-0.905956 13.0813 -0.905956 6.92766 2.71722 3.14662C4.47319 1.31464 6.80711 0.305664 9.29064 0.305664C11.7745 0.305664 14.1084 1.31464 15.8628 3.14662C17.6187 4.9786 18.5857 7.41399 18.5857 10.0045C18.5857 12.595 17.6187 15.0317 15.8628 16.8624C14.1071 18.6957 11.7732 19.7047 9.29064 19.7047C6.80841 19.7047 4.47319 18.6957 2.71852 16.8637ZM9.29064 2.83235C7.45499 2.83235 5.72829 3.57865 4.42993 4.93244C3.13157 6.28725 2.41637 8.08902 2.41637 10.0045C2.41637 11.9203 3.13157 13.7217 4.42993 15.0765C5.72829 16.4317 7.45499 17.1766 9.29064 17.1766C11.1279 17.1766 12.8533 16.4303 14.1517 15.0765C16.831 12.2807 16.831 7.72962 14.1504 4.9338C12.8533 3.57865 11.1266 2.83235 9.29064 2.83235Z",
    fill: "#25368D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2338 17.3158C18.2338 17.3158 18.0575 17.1315 17.8412 16.9061C17.6253 16.6808 17.2278 16.7259 16.9598 17.0056L16.0488 17.9562C15.7795 18.2372 15.7363 18.6509 15.9522 18.8762C16.1682 19.1016 16.3448 19.2872 16.3448 19.2872L18.2338 17.3158Z",
    fill: "#25368D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1381 20.1143L19.0274 18.1428L23.798 23.1222C24.0673 23.4032 24.0673 23.8621 23.798 24.1431L22.887 25.0923C22.6177 25.3733 22.178 25.3733 21.9087 25.0923L17.1381 20.1143Z",
    fill: "#25368D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch1);
export default __webpack_public_path__ + "static/media/icon-search-1.f011c35fcf7c62ac109c572c78425045.svg";
export { ForwardRef as ReactComponent };